import React from 'react';
import PropTypes from 'prop-types';
import PromotionCard from './PromotionCard';
import { SectionTitle, SectionSubtitle } from './styles';

const CategorySection = ({ category, promotions, selectedPromotionIds, onSelectPromotion }) => {
  if (promotions.length === 0) return null;

  return (
    <div style={{ marginBottom: 16 }}>
      <SectionTitle>{category.name}</SectionTitle>
      {category.description && (
        <SectionSubtitle>{category.description}</SectionSubtitle>
      )}

      {promotions.map((promotion) => (
        <PromotionCard
          key={promotion.id}
          promotion={promotion}
          isSelected={selectedPromotionIds.includes(promotion.id)}
          onSelect={onSelectPromotion}
        />
      ))}
    </div>
  );
};

CategorySection.propTypes = {
  category: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
  }).isRequired,
  promotions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedPromotionIds: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  onSelectPromotion: PropTypes.func.isRequired,
};

export default CategorySection;
